import { ApiFactory } from "@api/ApiFactory";
import { UserAccount } from "@domain/UserAccount";
import { useEffect, useState } from "react";

type UseAuthResult =
  | {
      userAccount: Accounts.Account;
      isAuthenticated: true;
      isLoading: false;
      invalidUserAccount: false;
    }
  | {
      userAccount: null;
      isAuthenticated: false;
      isLoading: boolean;
      invalidUserAccount: boolean;
    };

export const useAuth = (): UseAuthResult => {
  const [userAccount, setUserAccount] = useState<Accounts.Account | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [invalidUserAccount, setInvalidUserAccount] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await ApiFactory.authApi.userInfo();

        if (response.success) {
          const userInfo = response.data;

          const accountsResponse = await ApiFactory.accountsApi.getAccounts({
            emailKeyword: userInfo.email,
            includeOrganization: true,
            includeRelationAllType: true,
          });

          if (
            !accountsResponse ||
            accountsResponse.totalCount !== 1 ||
            accountsResponse?.data?.length !== 1
          ) {
            if (accountsResponse.totalCount === 0) {
              setInvalidUserAccount(true);
            }
            return;
          }
          setUserAccount(UserAccount.toDomain(accountsResponse.data[0]));
        }
      } catch (error) {
        console.error("Authentication check failed:", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (userAccount) {
    return {
      userAccount,
      isAuthenticated: true,
      isLoading: false,
      invalidUserAccount: false,
    };
  }
  return {
    userAccount: null,
    isAuthenticated: false,
    isLoading,
    invalidUserAccount,
  };
};
